import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  get(id) {
    return axios
      .get(adminPath(`/compliance_documents/verifications/${id}`))
      .then((response) => an('ComplianceDocumentVerification', response.data));
  },
  getVerifications(params) {
    return axios.get(adminPath('/compliance_documents/verifications?') + prepareQueryString(params)).then((response) => {
      return {
        verifications: response.data.map((complianceDocumentVerification) =>
          an('ComplianceDocumentCoverage', complianceDocumentVerification)
        ),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getComplianceDocumentVerifications(complianceDocumentCoverageId, params) {
    return axios
      .get(
        adminPath(`/compliance_documents/coverages/${complianceDocumentCoverageId}/verifications?`) +
          prepareQueryString(params)
      )
      .then((response) => {
        return {
          verifications: response.data.map((complianceDocumentVerification) =>
            an('ComplianceDocumentVerification', complianceDocumentVerification)
          ),
          total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
        };
      });
  },
  create(complianceDocumentCoverageId, data) {
    return axios
      .post(adminPath(`/compliance_documents/coverages/${complianceDocumentCoverageId}/verifications`), {
        ...data,
      })
      .then((response) => an('ComplianceDocumentVerification', response.data));
  },
  email(id, data) {
    return axios
      .post(adminPath(`/compliance_documents/${id}/current_coverage/verifications/email`), {
        ...data,
      })
      .then((response) => an('ComplianceDocument', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/compliance_documents/verifications.csv?') + prepareQueryString(params), {
      responseType: 'blob',
    });
  },
  getComplianceDocumentVerificationsSpreadsheet(params) {
    return axios.get(
      adminPath(`/compliance_documents/coverages/${params.complianceDocumentCoverageId}/verifications.csv?`) +
        prepareQueryString(params),
      {
        responseType: 'blob',
      }
    );
  },
};
